import AirDatepicker from 'air-datepicker';
import localeSv from 'air-datepicker/locale/sv';

class EventFilterList {
    constructor(rootElement) {
        this.rootElement = rootElement;
        this.attachEvents(rootElement);
    }

    attachEvents = (rootElement) => {
        const form = rootElement.querySelector('.event-filter-list__form');
        form.addEventListener('submit', this.onFormSubmit);

        const cityButton = rootElement.querySelector('.event-filter-list__select-city');
        const cityModal = rootElement.querySelector('.event-filter-list__cities');

        if (cityButton && cityModal) {
            cityButton.addEventListener('click', (e) => this.toggleCityDropdownVisibility(e));
            [...cityModal.querySelectorAll('.event-filter-list__city-button')].map((item) => {
                item.addEventListener('click', (e) => this.handleCityOnClick(e, item.innerText, cityButton));
            });
        }

        const showAllButton = rootElement.querySelector('.event-filter-list__show-all');
        if (showAllButton) {
            showAllButton.addEventListener('click', (e) => this.handleShowAllButtonOnClick(e, showAllButton))
        }

        const clearCityButton = rootElement.querySelector('.event-filter-list__clear-city');
        if (clearCityButton) {
            clearCityButton.addEventListener('click', (e) => this.handleClearCityButtonOnClick(e, clearCityButton))
        }

        const searchField = rootElement.querySelector('.event-filter-list__search');
        if (searchField) {
            searchField.addEventListener('input', (e) => this.handleSearchFieldOnChange(e))
        }

        const geolocationButton = rootElement.querySelector('.event-filter-list__position');
        if (geolocationButton && cityButton) {
            geolocationButton.addEventListener('click', (e) => this.handleGeolocationButtonOnClick(e, cityButton))
        }

        this.initializeDatePickers();
    }

    getHaversineDistanceFromInKm = (lat1, lon1, lat2, lon2) => {
        const R = 6371;
        const dLat = this.deg2rad(lat2 - lat1);
        const dLon = this.deg2rad(lon2 - lon1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;
        return distance;
    }

    deg2rad = (deg) => {
        return deg * (Math.PI / 180);
    }

    handleGeolocationButtonOnClick = (e, cityButton) => {
        const self = this;
        e.preventDefault();
        if (navigator.geolocation && window.eventFilterListGeolocations) {
            navigator.geolocation.getCurrentPosition((position) => {
                let closestCity = null;
                let closestDistance = Infinity;

                window.eventFilterListGeolocations.forEach(city => {
                    const distance = self.getHaversineDistanceFromInKm(position.coords.latitude, position.coords.longitude, city.Latitude, city.Longitude);

                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestCity = city;
                    }
                });
                console.log(`The closest city is ${closestCity.City}, which is ${closestDistance.toFixed(2)} km away.`);
                self.handleCityOnClick(e, closestCity.City, cityButton);
            },
                (error) => {
                    console.error("Error getting location: ", error.message);
                }
            );
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }

    handleSearchFieldOnChange = (e) => {
        e.preventDefault();
        this.submitForm();
    }

    doesShowAllButtonExist = () => {
        return !!this.rootElement.querySelector('.event-filter-list__show-all');
    }

    handleClearCityButtonOnClick = (e, clearCityButton) => {
        e.preventDefault();
        const hiddenCity = this.rootElement.querySelector('.event-filter-list__city');
        const cityButton = this.rootElement.querySelector('.event-filter-list__select-city');

        hiddenCity.value = '';
        cityButton.innerText = 'Välj ort';
        this.toggleCityDropdownVisibility(e);

        clearCityButton.classList.add('event-filter-list__clear-city--hidden');
        this.submitForm();
    }

    handleShowAllButtonOnClick = (e, button) => {
        e.preventDefault();
        [...this.rootElement.querySelectorAll('.event-filter-list__item--hidden')].map((item) => {
            item.classList.remove('event-filter-list__item--hidden')
        });
        button.parentElement.remove();
        this.submitForm();
    }

    handleCityOnClick = (e, cityName, cityButton) => {
        e.preventDefault();
        cityButton.innerText = cityName;
        this.toggleCityDropdownVisibility(e);

        const hiddenCity = this.rootElement.querySelector('.event-filter-list__city');
        hiddenCity.value = cityName;

        const clearCityButton = this.rootElement.querySelector('.event-filter-list__clear-city');
        if (clearCityButton && clearCityButton.classList.contains('event-filter-list__clear-city--hidden')) {
            clearCityButton.classList.remove('event-filter-list__clear-city--hidden');
        }

        this.submitForm();
    }

    setNoResultsVisibility = (show) => {
        const hiddenModifier = 'event-filter-list__no-result--hidden';
        const noResultsElement = this.rootElement.querySelector('.event-filter-list__no-result');

        if (show && noResultsElement.classList.contains(hiddenModifier)) {
            noResultsElement.classList.remove(hiddenModifier);
        }
        else if (!show && !noResultsElement.classList.contains(hiddenModifier)) {
            noResultsElement.classList.add(hiddenModifier);
        }
    }

    submitForm = () => {
        const hiddenModifier = 'event-filter-list__item--hidden';
        const city = this.getInputValue('.event-filter-list__city');
        const searchTerm = this.getInputValue('.event-filter-list__search');
        const minDate = this.getInputValue('#mindate');
        const maxDate = this.getInputValue('#maxdate');
        const elements = this.rootElement.querySelectorAll('.event-filter-list__item');
        const showAllWrap = this.rootElement.querySelector('.event-filter-list__show-all-wrap');
        this.setNoResultsVisibility(false);

        const hasFilter = city || searchTerm || minDate || maxDate;
        const doesShowAllButtonExist = this.doesShowAllButtonExist();

        if (doesShowAllButtonExist) {
            showAllWrap.classList.add('event-filter-list__show-all-wrap--hidden');
        }

        const maxItemsToShow = window.eventFilterListMaxItemsToShow;

        if (!hasFilter && doesShowAllButtonExist) {
            const totalHits = this.showFirstNItems(elements, maxItemsToShow, hiddenModifier);

            if (doesShowAllButtonExist && totalHits > maxItemsToShow) {
                showAllWrap.classList.remove('event-filter-list__show-all-wrap--hidden');
            }
            return;
        }

        const result = this.filterEvents(window.eventFilterListEvents, city, searchTerm, minDate, maxDate);
        this.updateElementVisibility(elements, result.eventsToShow, hasFilter, doesShowAllButtonExist, maxItemsToShow, hiddenModifier);

        if (doesShowAllButtonExist && result.totalHits > maxItemsToShow) {
            showAllWrap.classList.remove('event-filter-list__show-all-wrap--hidden');
        }

        if(result.totalHits === 0) {
            this.setNoResultsVisibility(true);
        }
    };

    getInputValue = (selector) => {
        return this.rootElement.querySelector(selector)?.value || '';
    };

    showFirstNItems = (elements, maxItemsToShow, hiddenModifier) => {
        elements.forEach(item => item.classList.add(hiddenModifier));
        const keys = Object.keys(window.eventFilterListEvents).slice(0, maxItemsToShow);
        let totalHits = 0;

        keys.forEach((key) => {
            const item = [...elements].find(el => el.dataset.id === key);
            if (item) {
                item.classList.remove(hiddenModifier);
                totalHits++;
            }
        });

        return Object.keys(window.eventFilterListEvents).length;
    };

    filterEvents = (events, city, searchTerm, minDate, maxDate) => {
        const eventsToShow = [];
        let totalHits = 0;

        for (const key in events) {
            if (events.hasOwnProperty(key)) {
                const event = events[key];
                if (this.matchesAllFilters(event, city, searchTerm, minDate, maxDate)) {
                    eventsToShow.push(key);
                    totalHits++;
                }
            }
        }

        return { eventsToShow: [...new Set(eventsToShow)], totalHits };
    };

    matchesAllFilters = (event, city, searchTerm, minDate, maxDate) => {
        return this.matchesCityFilter(event, city) &&
            this.matchesSearchFilter(event, searchTerm) &&
            this.matchesMinDateFilter(event, minDate) &&
            this.matchesMaxDateFilter(event, maxDate);
    };

    matchesCityFilter = (event, city) => {
        return !city || event.City === city;
    };

    matchesSearchFilter = (event, searchTerm) => {
        if (!searchTerm) return true;
        const lowerCaseSearchTerm = searchTerm.toLowerCase();
        return [event.Title, event.Description, event.City, event.Tag, event.Address].some(field =>
            field.toLowerCase().includes(lowerCaseSearchTerm)
        );
    };

    matchesMinDateFilter = (event, minDate) => {
        if (!minDate || !event.DateTime) return true;
        return new Date(event.DateTime) >= new Date(minDate);
    };

    matchesMaxDateFilter = (event, maxDate) => {
        if (!maxDate || !event.DateTime) return true;
        return new Date(event.DateTime) <= new Date(maxDate);
    };

    updateElementVisibility = (elements, eventsToShow, hasFilter, doesShowAllButtonExist, maxItemsToShow, hiddenModifier) => {

        elements.forEach((item) => {
            const isHidden = item.classList.contains(hiddenModifier);
            const shouldBeVisible = eventsToShow.includes(item.dataset.id);

            if (hasFilter) {
                this.handleFilterVisibility(item, shouldBeVisible, isHidden, hiddenModifier);
            } else {
                item.classList.remove(hiddenModifier);
            }
        });

        if (doesShowAllButtonExist) {
            this.limitVisibleItems(elements, eventsToShow, maxItemsToShow, hiddenModifier);
        }
    };

    handleFilterVisibility = (item, shouldBeVisible, isHidden, hiddenModifier) => {
        if (shouldBeVisible && isHidden) {
            item.classList.remove(hiddenModifier);
        } else if (!shouldBeVisible && !isHidden) {
            item.classList.add(hiddenModifier);
        }
    };

    limitVisibleItems = (elements, eventsToShow, maxItemsToShow, hiddenModifier) => {
        let visibleCount = 0;

        elements.forEach((item) => {
            const shouldBeVisible = eventsToShow.includes(item.dataset.id);
            if (shouldBeVisible) {
                if (visibleCount < maxItemsToShow) {
                    item.classList.remove(hiddenModifier);
                    visibleCount++;
                } else {
                    item.classList.add(hiddenModifier);
                }
            } else {
                item.classList.add(hiddenModifier);
            }
        });

        return visibleCount;
    };

    onFormSubmit = (e) => {
        e.preventDefault();
        this.submitForm();
    }

    toggleCityDropdownVisibility = (e) => {
        e.preventDefault();
        const cityButtonIcon = this.rootElement.querySelector('.event-filter-list__select-city + i');
        const cityModal = this.rootElement.querySelector('.event-filter-list__cities');

        if (cityButtonIcon && cityModal) {
            const isExpanded = cityModal.classList.contains('event-filter-list__cities--expanded');

            cityModal.setAttribute('aria-hidden', isExpanded);
            cityModal.classList.toggle('event-filter-list__cities--expanded');
            cityButtonIcon.classList.toggle('event-filter-list__field-icon--rotate');

            if (!isExpanded) {
                document.addEventListener('click', this.handleCityDropdownOutsideClick, true);
            } else {
                document.removeEventListener('click', this.handleCityDropdownOutsideClick, true);
            }
        }
    }

    handleCityDropdownOutsideClick = (e) => {
        const cityModal = this.rootElement.querySelector('.event-filter-list__cities');
        const cityButton = this.rootElement.querySelector('.event-filter-list__select-city');
        const cityButtonIcon = this.rootElement.querySelector('.event-filter-list__select-city + i');

        if (cityModal && !cityModal.contains(e.target) && !cityButton.contains(e.target)) {
            cityModal.classList.remove('event-filter-list__cities--expanded');
            cityModal.setAttribute('aria-hidden', 'true');
            cityButtonIcon.classList.remove('event-filter-list__field-icon--rotate');
            document.removeEventListener('click', this.handleCityDropdownOutsideClick, true);
        }
    }

    initializeDatePickers() {
        let minDatePicker, maxDatePicker;

        const self = this;
        minDatePicker = new AirDatepicker('#mindate', {
            autoClose: true,
            multipleDates: false,
            locale: localeSv,
            buttons: ['clear'],
            position: "bottom left",
            isMobile: false,
            minDate: new Date(),
            onSelect({ date }) {
                maxDatePicker.update({
                    minDate: date
                });
                self.submitForm();
            }
        });

        maxDatePicker = new AirDatepicker('#maxdate', {
            autoClose: true,
            multipleDates: false,
            locale: localeSv,
            position: screen.width <= 576 ? "bottom right" : "bottom left",
            buttons: ['clear'],
            isMobile: false,
            minDate: new Date(),
            onSelect({ date }) {
                minDatePicker.update({
                    maxDate: date ? date : new Date()
                });
                self.submitForm();
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const eventFilterLists = [...document.querySelectorAll('.event-filter-list')];
    eventFilterLists.map((rootElement) => {
        new EventFilterList(rootElement)
    })
});